import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../../data";
import { Reveal } from "./Reveal";

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="relative py-24 md:py-32 overflow-hidden">
    <div className="absolute top-0 -left-1/4 h-[50vh] w-[50vh] rounded-full bg-[#1a4b9b]/12 blur-[150px] pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <p className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-[#d4af37]">Client Stories</p>
        <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight text-white max-w-3xl">
          Families we've <span className="text-gold-gradient italic">stood beside.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 2) * 0.06}>
            <figure
              data-testid={`testimonial-${i}`}
              className="group relative h-full rounded-3xl border border-white/10 bg-[#0a192f] p-8 md:p-10 transition-colors duration-500 hover:border-[#bf953f]/40"
            >
              <Quote size={30} className="text-[#d4af37]/40" strokeWidth={1.2} />
              <blockquote className="mt-5 font-serif-display text-lg md:text-xl leading-relaxed text-white/80 italic">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 flex items-center justify-between gap-4">
                <div>
                  <p className="font-body text-sm font-medium tracking-wide text-white">{t.name}</p>
                  <p className="font-body text-xs tracking-wide text-white/45">{t.context}</p>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={13} className="fill-[#d4af37] text-[#d4af37]" />
                  ))}
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
